import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "../data";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white pt-20 pb-8 relative overflow-hidden" data-testid="site-footer">
      {/* Orange accent stripe */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-brand-orange" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="bg-white p-3 inline-block mb-6">
            <img src={COMPANY.logoUrl} alt="MRL Transports" className="h-14 w-auto" />
          </div>
          <p className="font-body text-sm text-zinc-300 leading-relaxed">
            Specialized transportation & logistics solutions for India's wind energy sector.
            Family-led, engineered for precision — since {COMPANY.founded}.
          </p>
        </div>

        <div>
          <p className="font-heading uppercase tracking-widest text-xs text-brand-orange mb-5">Navigate</p>
          <ul className="space-y-2 font-body text-sm">
            {NAV_LINKS.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  className="text-zinc-300 hover:text-brand-orange transition-colors"
                  data-testid={`footer-nav-${n.label.toLowerCase()}`}
                >
                  → {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-heading uppercase tracking-widest text-xs text-brand-orange mb-5">Services</p>
          <ul className="space-y-2 font-body text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.key} className="text-zinc-300">→ {s.title}</li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-heading uppercase tracking-widest text-xs text-brand-orange mb-5">Contact</p>
          <ul className="space-y-3 font-body text-sm">
            <li className="flex items-start gap-3 text-zinc-300">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-brand-orange" />
              <span>
                {COMPANY.offices.corporate.line1},<br />
                {COMPANY.offices.corporate.line2},<br />
                {COMPANY.offices.corporate.city}
              </span>
            </li>
            {COMPANY.phones.map((p) => (
              <li key={p.raw} className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 shrink-0 text-brand-orange" />
                <a
                  href={`tel:${p.raw}`}
                  className="text-zinc-300 hover:text-brand-orange transition-colors"
                  data-testid={`footer-phone-${p.raw}`}
                >
                  {p.value}
                </a>
              </li>
            ))}
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 shrink-0 text-brand-orange" />
              <a
                href={`mailto:${COMPANY.email}`}
                className="text-zinc-300 hover:text-brand-orange transition-colors break-all"
                data-testid="footer-email"
              >
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mt-16 pt-8 border-t border-zinc-800 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-mono text-xs text-zinc-500 tracking-wider uppercase" data-testid="footer-copyright">
          © {new Date().getFullYear()} MRL Transports. All rights reserved.
        </p>
        <p className="font-mono text-xs text-zinc-500 tracking-wider uppercase">
          Namakkal → India → Worldwide
        </p>
      </div>
    </footer>
  );
}
